export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title: that.$l('INDEX.log_label_businessType') || '业务类型',
    field: 'businessType',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.log_label_operationBy') || '操作人',
    field: 'operationByName',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.log_label_operationTime') || '操作时间',
    field: 'operationTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.log_label_operationDesc') || '业务说明',
    field: 'operationDesc',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  }
]
